export default __webpack_public_path__ + "static/media/info.cefc61ce.svg";